export default "__VITE_ASSET__8n2X21Tc__"